export enum TabNameEnum {
    GENERAL = 'general',
    ITEMS = 'items',
    ADDRESSES = 'addresses',
    ATTACHMENTS = 'attachments',
    CONTACT = 'contact',
    NOTES = 'notes',
    INVOICES = 'invoices',
}
